export const darkTheme = {
  bg: "#0a0a0f",
  bgLight: "#13131a",
  primary: "#854CE6",
  secondary: "#6366f1",
  text_primary: "#F2F3F4",
  text_secondary: "#b1b2b3",
  card: "#171721",
  card_light: "#1a1a2e",
  button: "#854CE6",
  white: "#FFFFFF",
  black: "#000000",
  gradient: "linear-gradient(135deg, #854CE6 0%, #6366f1 50%, #ec4899 100%)",
};

export const lightTheme = {
  bg: "#FFFFFF",
  bgLight: "#f0f0f0",
  primary: "#854CE6",
  secondary: "#6366f1",
  text_primary: "#111111",
  text_secondary: "#48494a",
  card: "#FFFFFF",
  card_light: "#f8f8f8",
  button: "#854CE6",
  white: "#FFFFFF",
  black: "#000000",
  gradient: "linear-gradient(135deg, #854CE6 0%, #6366f1 50%, #ec4899 100%)",
};
